import { render, staticRenderFns } from "./common-tabs-2.vue?vue&type=template&id=0b2ba5fc&scoped=true&"
import script from "./common-tabs-2.vue?vue&type=script&lang=js&"
export * from "./common-tabs-2.vue?vue&type=script&lang=js&"
import style0 from "./common-tabs-2.vue?vue&type=style&index=0&id=0b2ba5fc&lang=scss&scoped=true&"
import style1 from "./common-tabs-2.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b2ba5fc",
  null
  
)

export default component.exports